/**
 * Returns closest parent element
 * that matches the given selector parameter
 */
const getClosest = (el, sel) => {
  while (el !== null) {
    const parent = el.parentElement
    if (
      parent !== null &&
      (
        parent.matchClass ||
        parent.matchesSelector ||
        parent.msMatchesSelector ||
        parent.mozMatchesSelector ||
        parent.webkitMatchesSelector ||
        parent.oMatchesSelector
      ).call(parent, sel)
    ) {
      return parent
    }
    el = parent
  }
  return null
}

export default getClosest
